import { render, staticRenderFns } from "./neighbourhood.vue?vue&type=template&id=6dd5aa55&scoped=true"
import script from "./neighbourhood.vue?vue&type=script&lang=js"
export * from "./neighbourhood.vue?vue&type=script&lang=js"
import style0 from "./neighbourhood.vue?vue&type=style&index=0&id=6dd5aa55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd5aa55",
  null
  
)

export default component.exports